<template>
    <Teleport to="#vue-related-resources-list">
    <a
        v-for="keyword in related"
        :href="keyword.url" class="keyword-link">{{ keyword.data.keyword }}</a>
    </Teleport>

</template>

<script>
export default {
    name: "RelatedResourcesList"
}
</script>


<script setup>

    import { computed, watch, onMounted } from "vue";
    import { useStore } from "vuex";

    let store = useStore();

    let related = computed( () => store.state.related );

    function cleanUp ()
    {
        document.querySelector("#related-resources-list").innerHTML = "";
    }

    function displayContainer ()
    {
        let count = related.value.length;
        let container =  document.querySelector("#related-container");

        if (count > 0)
        {
            container.classList.remove("d-none");
        }
        else
        {
            container.classList.add("d-none");
        }
    }

    defineExpose({cleanUp})


    watch ( () => related.value, () => displayContainer())


    function mounted ()
    {
        displayContainer();
    }

    onMounted(mounted);

</script>
<style scoped>

</style>
